jQuery( window ).on( 'load', function( $ ) {

	//KONAMI RAINBOW



	function loop(fn, min, max) {
		var rand = Math.round(Math.random() * (min - max)) + max;
		console.log('Activate '+ fn.name +' in: '+ rand / 1000.0+'s');
		setTimeout(function() {
				fn();
			loop(fn, min, max);
		}, rand);
	}

	// Constants
	const STAGE = 'stage'

	const MENU_ID = 'menu';  // Menu identifier
	const MENU_ITEM = '#menu .menu-item';  // Menu item identifier

	const INTERACTABLE = 'interactable';  // Classname for interactable elements

	const CTRL_REMOVE_ID = '#ctrlRemove';
	const CTRL_RAISE_ID  = '#ctrlRaise';
	const CTRL_LOWER_ID  = '#ctrlLower';
	const CTRL_ROTATE_ID = '#ctrlRotate';
	const CTRL_UNDO_ID   = '#ctrlUndo';

	const ROTATE_CONTROL_ID = 'rotate-control';

	const SELECTED = 'selected';  // Class to indicate a selected item


	/**
	 * An 'abstract' object from which to inherit common element properties.
	 *
	 * This prototype assumes that the child object has a property 'element'
	 * that is a DOM element.
	 */
	var ElementProperties = {}
	ElementProperties.prototype = {

		element: null, // This should be set by the child object


		/**
		 * Height dynamic property.
		 */
		get height() {
			// Don't try to get the height of a cloned element that hasn't yet been placed.
			if ( ! this.element.parentNode ) { return null;  }

			if ( this._height ) {
				return this._height;
			} else {
				var rect = this.element.getBoundingClientRect();
				this._height = rect.bottom - rect.top;

				return this._height;
			}
		},
		set height( height ) {
			this._height = height;
		},


		/**
		 * Width dynamic property.
		 */
		get width() {
			// Don't try to get the height of a cloned element that hasn't yet been placed.
			if ( ! this.element.parentNode ) { return null;  }

			if ( this._width ) {
				return this._width;
			} else {
				var rect = this.element.getBoundingClientRect();
				this._width = rect.right - rect.left;

				return this._width;
			}
		},
		set width( width ) {
			this._width = width;
		},


		/**
		 * Sets up an event handler for both tap and click events in such a way
		 * that we prevent "phantom taps" -- when both the click event and the
		 * touchend events are fired for one event. Also tests for and ignores
		 * drag events.
		 *
		 * @param function handler - the function to handle the event
		 * @param element - element on which to put the events
		 */
		onClickTap: function( handler, element) {
			element = element || this.element; // Create a closure on the element

			var dragging = false; // Create a closure on a dragging flag

			/**
			 * Notice and flag drag events to ignore.
			 */
			jQuery( element ).on( 'touchmove', function ( event ) {
				dragging = true;
			});

			/**
			 * Handles touchend events (when not dragging).
			 */
			jQuery( element ).on( 'touchend', function ( event ) {
				if ( ! dragging ) {
					handler( event );
				}
				dragging = false;  // We are at the end of the 'touch', so reset dragging flag
				element.tapEventHandled = true;
			});

			/**
			 * When this event is fired, check to see if the element's
			 * tabEventHandled flag was set. If so, unset it.
			 * If not, handle the event like normal.
			 */
			jQuery( element ).on( 'click', function ( event ) {
				if ( element.tapEventHandled ) {
					element.tapEventHandled = false;
					return;
				}
				if ( ! dragging ) {
					handler( event );
				}
			});
		},


		/**
		 * Sets up an event handler for *only* click events. Tap events, which
		 * should happen first, will prevent the handler from being run.
		 *
		 * @param function handler - the function to handle the event
		 */
		onClickNotTap: function( handler ) {

			var element = this.element;  // Create a closure on the element

			/**
			 * Handles touchstart events.
			 */
			jQuery( element ).on( 'touchstart', function ( event ) {
				element.tapEventHappened = true;
			});

			/**
			 * When this event is fired, check to see if the element's
			 * tabEventHandled flag was set. If so, unset it for the next time.
			 * If not, handle the event like normal.
			 */
			jQuery( element ).on( 'click', function ( event ) {
				if ( element.tapEventHappened ) {
					element.tapEventHappened = false;
				} else {
					handler( event );
				}
			});
		}
	};



	/**
	 * The Item object is an object that can be placed on the stage.
	 *
	 * @param element - should be a cloned MenuItem element
	 * @param attributes - an object literal of this type:
	 * 			{
	 * 				name   : item,  // item name (id of MenuItem)
	 * 				x      : 0,     // item x position on stage
	 * 				y      : 0,     // item y position on stage
	 * 				width  : (auto) // item width
	 * 				height : (auto) // item height
	 * 				angle  : 0,     // item angle of rotation (0 is no rotation)
	 * 			}
	 */
	function Item( element, attributes ) {

		this.element = element;
		this.element.item = this;  // Store a reference to this object on the element.

		this.name = attributes.name || 'item';

		this.x = attributes.x || 0;
		this.y = attributes.y || 0;
		if ( attributes.width ) { this.width = attributes.width; }
		if ( attributes.height ) { this.height = attributes.height; }
		this.angle = attributes.angle || 0;

		this.place().resize().rotate();  // Set initial position, size, and rotation

		this.flipped = false;  // Start out normal
		if ( attributes.flipped ) { this.flip(); }  // Flip, if flipped attribute is set

		this.rotationControl = new RotationControl( this );
	}
	// Inherit from ElementProperties
	Item.prototype = Object.create( ElementProperties.prototype );

	/**
	 * Sets the item's position properties and positions the item on the
	 * screen.
	 *
	 * @param int x
	 * @param int y
	 *
	 * @return Item - returns the instance to be fluent
	 */
	Item.prototype.place = function( x, y) {
		this.x = x = x || this.x;  // Uses (this.x, this.y) if
		this.y = y = y || this.y;  // no args are passed.

		// this.element.style.left = x + '%';
		// this.element.style.top = y + '%';
		this.element.style.left = '50%';
		this.element.style.marginLeft = x + 'px';
		this.element.style.marginTop = y + 'px';
		this.element.style.top = '50%';

		return this;
	};

	/**
	 * Moves item by dx, dy.
	 *
	 * @param int dx - amount to move by in x axis
	 * @param int dy - amount to move by in y axis
	 *
	 * @return Item - returns the instance to be fluent
	 */
	Item.prototype.move = function( dx, dy ) {
		dx = dx || 0
		dy = dy || 0
		// var px_offset = ( dx / stage.width ) * 100;  // Convert to percentages
		// var py_offset = ( dy / stage.height ) * 100;
		if( this.x + dx >= stage.width/2 ){ // Convert to px from center
			var px_offset = dx;
		}else{
			var px_offset = dx;
		}
		var py_offset = dy;
		// console.log('dx:'+dx+ ' | this.x:'+this.x+' | dy:'+dy+' this.y: '+this.y);
		this.place( this.x + px_offset, this.y + py_offset, this.angle );

		return this;
	};

	/**
	 * Resize item to width, height.
	 *
	 * @param int width
	 * @param int height
	 *
	 * @return Item - returns the instance to be fluent
	 */
	Item.prototype.resize = function( width, height) {
		width = width || null;
		height = height || null;
		// Prevent shrinking Item too much
		if ( width && 50 > width ) { return this; }
		if ( height && 50 > height ) { return this; }

		// Prevent resizing Item too large
		if ( width && 500 < width ) { return this; }
		if ( height && 500 < height ) { return this; }

		this.width = width = width || this.width;      // Uses (this.width, this.height)
		this.height = height = height || this.height;  // if no args are passed.

		this.element.style.width  = this.width + 'px';
		this.element.style.height = this.height + 'px';

		return this;
	};

	/**
	 * Rotate item.
	 *
	 * @param int angle
	 *
	 * @return Item - returns the instance to be fluent
	 */
	Item.prototype.rotate = function( angle ) {
		// Uses this.angle if no args are passed
		angle = angle || this.angle;

		this.angle = angle;

		var cx = jQuery( this.element ).data( 'width' ) / 2;
		var cy = jQuery( this.element ).data( 'width' ) / 2;

		// Change the item's rotation
		this._transform_rotate = ' rotate(' + angle + ' ' + cx + ' ' + cy + ') ';

		return this.transform();
	};

	/**
	 * Flip item.
	 *
	 * @return Item - returns the instance to be fluent
	 */
	Item.prototype.flip = function() {
		if ( this.flipped ) {  // Turn the item right
			// Change the item's rotation
			this._transform_scale = ' scale(1,1) ';

			// Change the item's rotation
			this._transform_translate = ' translate(0, 0) ';

			this.flipped = false;

		} else {  // Otherwise flip it backwards

			// Change the item's rotation
			this._transform_scale = ' scale(-1,1) ';

			// Change the item's rotation
			this._transform_translate = ' translate(-' + jQuery( this.element ).data( 'width' ) + ', 0)';

			this.flipped = true;
		}

		return this.transform();
	};

	/**
	 * Set transform attributess on item
	 *
	 * @return Item - returns the instance to be fluent
	 */
	Item.prototype.transform = function() {
		var transform_string = ( this._transform_rotate || '' ) + ( this._transform_scale || '' ) + ( this._transform_translate || '' );

		jQuery( this.element ).children( 'g' )
			.attr( 'transform', transform_string );

		return this;
	};

	/**
	 * Returns item data for serializing.
	 */
	Item.prototype.serialize = function() {
		return {
				'name'   : this.name,
				'x'      : this.x,
				'y'      : this.y,
				'angle'  : this.angle,
				'width'  : this.width,
				'height' : this.height,
				'flipped' : this.flipped
			};
	};



	/**
	 * Rotation control element
	 *
	 * This control is placed over the selected item.
	 * A control is cloned from the master control in the html and a new
	 * propeller object is initialized every time a new control is needed.
	 *
	 * It inherits from the Item object's prototype.
	 *
	 * @param Item
	 */
	function RotationControl( item ) {
		this.item = item;  // Item to be controlled
		// Also available in this function scope via closure

		// Control element.
		var control = document.getElementById( ROTATE_CONTROL_ID );
		if( ! control ) { return; }
		this.element = control.cloneNode( true );
		this.element.id = '';  // Remove id to prevent conflicts

		// Put on stage
		stage.element.appendChild( this.element );

		// NOTE: this is using arg 'item' as a closure
		this.propeller = new Propeller( this.element, {
			inertia: 0.87,

				// Rotate selectedItem
			onRotate: function () {
				if ( item ) { item.rotate( this.angle ); }
			},
				// Set the Event flag.
			onDragStart: function() {
				if ( item ) { stage.rotationControlClickEvent = true; }
			},

				// Save the state (with the new rotation angle).
			onStop: function () {
				if ( item ) { stage.saveState(); }  // May have timing issues or delays due to inertia
			},
		});

	};
	// Inherit from ElementProperties
	RotationControl.prototype = Object.create( ElementProperties.prototype );

	/**
	 * Shows RotationControl.
	 */
	RotationControl.prototype.show = function() {
		this.position();  // Position the element first.
		this.element.style.display = 'block';
	};

	/**
	 * Hides RotationControl.
	 */
	RotationControl.prototype.hide = function() {
		this.element.style.display = 'none';
	};

	/**
	 * Position RotationControl.
	 */
	RotationControl.prototype.position = function() {
		// Starting with the largest of the width or height and offsetting
		// position in the opposite direction by half of the difference
		// between the two. The size is adjusted to make it slightly larger
		// than the item.
		var size, adjustment, x, y;
		if ( this.item.height < this.item.width ) {
			adjustment = this.item.width * 0.5;  // Adjust the size a bit larger than largest side
			size = this.item.width + adjustment;
			offset_x = ( adjustment / 2 );
			offset_y = ( adjustment / 2 ) + ( ( this.item.width - this.item.height ) / 2 );
		} else {
			adjustment = this.item.height * 0.5;
			size = this.item.height + adjustment;
			offset_x = ( adjustment / 2 ) + ( ( this.item.height - this.item.width ) / 2 );
			offset_y = ( adjustment / 2 );
		}

		// Make rotation control at least 50px x 50px
		if ( size < 50 ) {
			size = 50;
			offset_x = ( size - this.item.width ) / 2;
			offset_y = ( size - this.item.height ) / 2;
		}

		// Set the size a bit larger than the object
		this.element.style.width = size + 'px';
		this.element.style.height = size + 'px';

		// Position in the center
		this.element.style.position = 'absolute';
		this.element.style.left = '50%';
		this.element.style.top = '50%';

		// Offset based on size differences
		x = this.item.x - offset_x;
		y = this.item.y - offset_y;
		// Offset by using margin:
		this.element.style.marginLeft = x + 'px';
		this.element.style.marginTop = y + 'px';
	};



	/**
	 * MenuItem object is a menu item to be selected as Item(s) to put on the
	 * stage.
	 *
	 * !! MenuItem elements MUST have an id for things to work properly. !!
	 */
	function MenuItem( element ) {

		this.element = element;
		this.element.menu_item = this;  // Store a reference to this object on the element.

		// NOTE: If the menu item does not have an id set, it will cause issues when redrawing.
		this.name = this.element.id || 'item';

		var rect = this.element.getBoundingClientRect();
		this.top = rect.top;
		this.left = rect.left;


		// Setup MenuItem click event handler
		this.onClickTap( function( event ) {
			var target = element;  // element is a closure (see the arg of MenuItem)

			var clone = target.menu_item.clone();
			var attributes = {
				// This is where we set the intial item position.
				// Placing in the middle of the stage
				x: 50 - ( ( target.menu_item.width / 2 ) / stage.width ),
				y: 50 - ( ( target.menu_item.height / 2 ) / stage.height ),
				name: target.menu_item.name,
			};

			// Add a class to animate in
			jQuery( clone ).addClass( 'bounceInDown animated' );

			var item = stage.addItem( clone, attributes );

			// Remove the animate class
			setTimeout( function() {
				jQuery( item.element ).removeClass( 'bounceInDown animated' );
			}, 1000);

			// DOM element of the item:
			// item.element

		}, this.element.parentNode );


		/**
		 * Clones the item for placing on stage.
		 *
		 * @return element clone - returns a cloned DOM element
		 */
		this.clone = function() {
			var clone = this.element.cloneNode( true );

			clone.id = '';  // Remove id to prevent duplicate ids
			jQuery(clone).addClass( INTERACTABLE );
			clone.style.position = 'absolute';

			return clone;
		};
	}
	// Inherit from ElementProperties
	MenuItem.prototype = Object.create( ElementProperties.prototype );



	/**
	 * Menu object container for MenuItems.
	 */
	var menu = {

		/**
		 * Inherit from ElementProperties
		 */
		__proto__: Object.create( ElementProperties.prototype ),

		/**
		 * Menu container element.
		 */
		element: document.getElementById( MENU_ID ),

		/**
		 * Associative array of MenuItems in the menu
		 */
		items: [],


		/**
		 * Initializes menu.
		 */
		init: function() {
			// Load menu items from dom into this object
			jQuery( MENU_ITEM ).each( function( i, menu_item ) {
				menu.items[menu_item.id] = new MenuItem( menu_item );
			});


            // TODO: Remove this for mobile
			/**
			 * Interact setup for draggable snowman menu items.
			 *
			 * These items aren't technically 'interactable'. They are merely
			 * cloned and a draggable_item interaction is started on the clone.
			 *
			 * This is an alternative to simply clicking on the item.
			 */ /**
			interact( MENU_ITEM ).draggable( { inertia: true } )
					// Set flag if touch event occurred.
				.on( 'touchstart', function( event ) { event.currentTarget.tapEventHappened = true; })
				.on( 'move', function( event ) {
					var interaction = event.interaction;

					if ( interaction.interacting() || ! interaction.pointerIsDown ) {
						return;  // Already interacting or pointer is not down
					}

					// Don't move if tap event was detected.
					if ( event.currentTarget.tapEventHappened ) {
						event.currentTarget.tapEventHappened = false;  // Reset flag.
						return;
					}

					var target = event.currentTarget;

					var element = target.menu_item.clone();
					var attributes = {
						// Determine the original x and y values
						x: target.getBoundingClientRect().left - stage.left,
						y: target.getBoundingClientRect().top - stage.top,
						name: target.menu_item.name,
					};

					// Put the item on the stage at the original location
					var item = stage.addItem( element, attributes );

					// Quickly adjust item based on item's size transformation
					// This has to be done after the element is placed,
					// otherwise, it won't yet have a height/width.
					var dx = ( item.width - target.menu_item.width ) / 2;
					var dy = ( item.height - target.menu_item.height ) / 2;
					item.move(-dx, -dy);

					// Begin the interaction with the item (not the menu item).
					interaction.start({
							name: 'drag',
						}, stage.interaction, item.element );
				});
		*/

			return this;
		},
	}



	/**
	 * Stage object on which to place items.
	 */
	var stage = {

		/**
		 * Inherit from ElementProperties
		 */
		__proto__: Object.create( ElementProperties.prototype ),

		/**
		 * Initializes stage.
		 */
		init: function() {

			/**
			 * Stage click event handler.
			 *
			 * Note that the individual items themselves do not have click
			 * events. Anytime the stage or anything else is clicked inside the
			 * stage element, this event is fired. stage.selectItem() follows
			 * the target up the DOM to the item element container. If an item
			 * element is not found, nothing is selected.
			 */
			this.onClickTap( function( event ) {

				// If the target was the rotationControl, do nothing
				if ( event.target.parentNode === stage.rotationControl ) { return; }

				// If the click event occurred on the "mouseUp" of a
				// rotationControlClickEvent, do nothing
				if ( stage.rotationControlClickEvent ) {
					stage.rotationControlClickEvent = false;  // Reset the flag.
					return;
				}

				stage.selectItem( event.target );
			});


			/**
			 * Window resize events.
			 */
			window.onresize = function( event ) {
				stage.resize();  // Keep stage.height and stage.width current
			};


			// Initialize control click handlers
			jQuery( CTRL_REMOVE_ID ).click( this.removeItem );
			jQuery( CTRL_RAISE_ID ).click( this.raiseItem );
			jQuery( CTRL_LOWER_ID ).click( this.lowerItem );
			jQuery( CTRL_ROTATE_ID ).click( this.rotateItem );
			jQuery( CTRL_UNDO_ID ).click( this.undo );

			// Set up interact js on interactable objects
			this.interaction = interact( '.' + INTERACTABLE )
				.draggable({
					inertia: true,
					restrict: {
						restriction: 'parent',
						endOnly: true,
						elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
					},

					onmove: this.dragItem,
					onend: this.saveState

					/**  TODO: Fix Issue with rotating resizing.
				}).resizable({
					preserveAspectRatio: true,
					edges: { left: true, right: true, bottom: true, top: true },

					onmove: this.resizeItem,
					onend: this.saveState

				}).gesturable({
					onmove: this.resizeItem,
					onend: this.saveState
					*/
				});


			this.resize();  // Set initial height/width and center coordinates
			this.saveState();  // Saves the first state as an empty stage


			// Don't do rabit animation for /image
			if( ! ( window.location.href.indexOf("image") >= 0 ) ){


				function showRabbit() {
					jQuery('.rabbit').show();
					setTimeout(function() { jQuery('.rabbit').hide(); }, 20000);
				}
				loop(showRabbit,23000,180000);

				function showUFO() {
					jQuery('.ufo').show();
					setTimeout(function() { jQuery('.ufo').hide(); }, 10000);
				}
				loop(showUFO,100000,180000);
			}

			setTimeout(function() { jQuery(window).trigger('resize'); }, 1500);

			return this;
		},


		/**
		 * Stage container element.
		 */
		element: document.getElementById( STAGE ),


		/**
		 * Snowman url
		 */
		url: {
			get edit()    { return '//' + app.siteurl + '/edit/'    + ( ( app.user ) ? app.user : '' ); },
			get preview() { return '//' + app.siteurl + '/preview/' + ( ( app.user ) ? app.user : '' ); },
			get image()   { return '//' + app.siteurl + '/image/'   + ( ( app.user ) ? app.user : '' ); },
			get card()    { return '//' + app.siteurl +    ( ( app.user ) ? '/card/' + app.user : '' ); },
			get save()    { return '//' + app.siteurl + '/save/'    + ( ( app.user ) ? app.user : '' ); },
			get reload()  { return '//' + app.siteurl + '/reload/'  + ( ( app.user ) ? app.user : '' ); },
		},


		/**
		 * Array of Items currently on the stage.
		 */
		items: [ ],

		/**
		 * Flag for whether or not to show northern lights
		 */
		northern_lights: false,


		/**
		 * Gets height, width, and center coordinates.
		 */
		resize: function() {
			var rect = this.element.getBoundingClientRect();

			this.height = rect.bottom - rect.op;
			this.width = rect.right - rect.left;

			this.top = rect.top;
			this.left = rect.left;

			this.center = {
				x: this.width / 2,
				y: this.height / 2,
			}
		},


		/**
		 * Initialize a new menu.
		 */
		menu: menu.init(),


		/**
		 * References to the currently selected (focused) item and element.
		 */
		selectedItem: null,
		selectedElement: null,


		/**
		 * Selects an element (and de-selects previously focused element).
		 *
		 * If element is null or not an interactable element on the stage,
		 * nothing is selected.
		 *
		 * @param element - DOM element to select
		 */
		selectItem: function( element ) {
			// If there is a selected element and it is the element to select, there's nothing to do
			if ( stage.selectedElement && stage.selectedElement === element ) { return element; }

			// Everytime a new item is selected, hide any possible current rotationControl
			if ( stage.rotationControl ) { stage.rotationControl.hide(); }

			// Deselect previously selected item/element
			jQuery( stage.selectedElement ).removeClass( SELECTED );
			stage.selectedItem = null;
			stage.selectedElement = null;

			// If no elements are selected, nothing to do.
			if ( ! element ) { return null; }

			// Find the element that is the parent element of the item.
			// We are checking that the element exists and that we
			// haven't worked our way up the dom past the stage element.
			// The item should have the class INTERACTABLE
			while ( element !== null && element !== stage.element ) {
				if ( jQuery( element ).hasClass( INTERACTABLE ) ) {
					stage.selectedItem = element.item;
					stage.selectedElement = element;
					break
				}
				element = element.parentNode;  // Repeat trying with parent element
			}

			// Add class for styling
			jQuery( stage.selectedElement ).addClass( SELECTED );

			return stage.selectedElement;
		},


		/**
		 * Selects the topmost element (and de-selects previously focused element).
		 *
		 * @return element - returns the selected element
		 */
		selectTopmostItem: function() {
			element = ( stage.items.length !== 0 ) ? stage.items[stage.items.length - 1].element : null;
			return this.selectItem( element );
		},


		/**
		 * Creates an item by cloning a menu item, adding it to
		 * stage.items array, and putting it on the stage.
		 *
		 * @param element - element to place on screen
		 * @param int attributes - see Item object
		 *
		 * @return element - returns the Item instance
		 */
		createItem: function( element, attributes ) {
			var item = new Item( element, attributes );

			// Add item to items array
			this.items.push( item );

			// Put item on stage
			this.element.appendChild( item.element );

			return item;
		},


		/**
		 * Clones an item (element) and puts it on the stage
		 *
		 * @param element - MenuItem cloned element
		 * @param int attributes - see Item object
		 *
		 * @return element - returns the Item instance
		 */
		addItem: function( element, attributes ) {
			var item = stage.createItem( element, attributes );

			// Make this item the selected (focused) item
			stage.selectItem( item.element );

			stage.saveState();

			return item;
		},


		/**
		 * Event handler for drag events.
		 *
		 * @param event drag_event - event object
		 */
		dragItem: function( drag_event ) {
			drag_event.target.item.move( drag_event.dx, drag_event.dy );
		},


		/**
		 * Event handler for resize events.
		 *
		 * @param event resize_event - event object
		 */
		resizeItem: function( resize_event ) {
			resize_event.target.item
				.resize( resize_event.rect.width, resize_event.rect.height )
				.move( resize_event.deltaRect.left, resize_event.deltaRect.top );
		},


		/**
		 * Rotation control object
		 */
		rotationControl: null,

		/**
		 * A boolean that is flagged immediately after rotating the rotation
		 * control. If the mouse moves off the control, it will register as a
		 * different element and the control will disappear in an annoying
		 * manner.  This helps to aleviate the problem.
		 */
		rotationControlClickEvent: false,


		/**
		 * Event handler to show rotation control for rotating the item.
		 *
		 * @param event rotate_event - event object
		 */
		rotateItem: function( rotate_event ) {

			// If there are no items, there's nothing to do
			if ( stage.items.length < 1 ) { return; }

			var selected_item = stage.selectedItem;

			// If there isn't a selected item, select the top one.
			if ( ! selected_item ) { selected_item = stage.selectTopmostItem(); }

			stage.rotationControl = selected_item.rotationControl;
			stage.rotationControl.show();
		},


		/**
		 * Event handler to flip item.
		 *
		 * @param event flip_event - event object
		 */
		flipItem: function( flip_event ) {

			// If there are no items, there's nothing to do
			if ( stage.items.length < 1 ) { return; }

			var selected_item = stage.selectedItem;

			// If there isn't a selected item, select the top one.
			if ( ! selected_item ) { selected_item = stage.selectTopmostItem(); }

			selected_item.flip();
		},


		/**
		 * Event handler to raise selectedElement in DOM.
		 *
		 * @param event raise_event - event object
		 */
		raiseItem: function( raise_event ) {
			// If there isn't a selected item, there's nothing to do
			if ( ! stage.selectedElement ) { return; }

			// Everytime a new item is selected, hide any possible current rotationControl
			if ( stage.rotationControl ) {
				stage.rotationControl.hide();
			}

			var item_index = stage.items.indexOf( stage.selectedItem );

			if ( stage.items.length > item_index + 1) {  // If there is an item to raise above

				// First, set the order in stage.items[]
				var item_to_move = stage.items.splice( item_index, 1 )[0];
				stage.items.splice( item_index + 1, 0, item_to_move);

				// Then insert selectedElement before next item to raise in the DOM
				stage.element.insertBefore( stage.items[item_index].element, stage.selectedElement );
			}

			stage.saveState();
		},


		/**
		 * Event handler to lower selectedElement in DOM.
		 *
		 * @param event lower_event - event object
		 */
		lowerItem: function( lower_event ) {
			// If there isn't a selected item, there's nothing to do
			if ( ! stage.selectedElement ) { return; }

			// Everytime a new item is selected, hide any possible current rotationControl
			if ( stage.rotationControl ) {
				stage.rotationControl.hide();
			}

			var item_index = stage.items.indexOf( stage.selectedItem );

			if ( item_index > 0 ) {  // If there is an item to raise above

				// First, set the order in stage.items[]
				var item_to_move = stage.items.splice( item_index, 1 )[0];
				stage.items.splice( item_index - 1, 0, item_to_move);

				// Then, insert next item before selectedElement to lower selectedElement in the DOM
				stage.element.insertBefore( stage.selectedElement, stage.items[item_index].element );

			}  // Otherwise, nothing to lower item below

			stage.saveState();
		},


		/**
		 * Event handler to remove selectedElement from DOM.
		 *
		 * @param event remove_event - event object
		 */
		removeItem: function( remove_event ) {

			if ( ! stage.selectedElement ) { return; }

			// Remove selectedItem from array
			stage.items.splice( stage.items.indexOf( stage.selectedItem ), 1 );

			// Remove selectedItem from stage
			jQuery(stage.selectedElement).remove();

			// Select the highest element (or the last element)
			stage.selectTopmostItem();

			stage.saveState();
		},



		states: [ ],  // Array to hold stage states for undo/redo


		/**
		 * Save state method for undo/redo
		 *
		 * Note that events should occur *after* the change for
		 * consistency. This means that the current state is reflected
		 * by the topmost item on the stage.states array.
		 */
		saveState: function() {
			stage.states.push( stage.serialize() );
		},


		/**
		 * Undo event handler.
		 *
		 * Must remove the current state before applying the previous
		 * state.
		 *
		 * @param event undo_event - event object
		 */
		undo: function( undo_event ) {
			stage.states.pop();  // Remove current state

			// Only store the last 10 states
			if ( stage.states.length > 10 ) {
				stage.states.shift(); // Remove the oldest
			}

			// Redraw previous state if there is one
			if ( stage.states.length > 0 ) {
				stage.clear();  // Empty the stage
				stage.draw( stage.states[stage.states.length - 1] );
			}

			// Select the highest element (or the last element)
			stage.selectTopmostItem();

			return this;
		},


		/**
		 * Clears the stage of everything
		 */
		clear: function() {
			for ( i = 0, j = stage.items.length; i < j; i++ ) {
				stage.element.removeChild( stage.items[i].element );
			}
			stage.items = [];

			return this;
		},


		/**
		 * Serializes items/stage into json.
		 *
		 * @return string (json)
		 */
		serialize: function() {
			var data = {
				items: [],
				northern_lights: this.northern_lights,
				stage: {
					width: this.width,
					height: this.height,
				},
			};
			for( var i = 0, len = this.items.length; i < len; i++ ) {
				data.items.push( this.items[i].serialize() );
			}
			return JSON.stringify( data );
		},


		/**
		 * Draws a previously saved snowman.
		 *
		 * @param string (json) - serialized Items object
		 */
		draw: function( serialized_data ) {
			var data = JSON.parse( serialized_data ); //THIS BREAKS ON /IMAGE - MJS
			// var data = serialized_data;
			if ( ! data.items ) { return this; }
			for( var i = 0, len = data.items.length; i < len; i++ ) {
				var element = this.menu.items[data.items[i].name].clone();

				this.createItem( element, data.items[i] );
			}
			this.selectTopmostItem();

			return this;
		},

		/**
		 * Saves a snowman to the db
		 */
		save: function() {
			var button = jQuery( '.save-button .editor-functions-toolbar__button__description, #save-status' );

			button.text( 'Saving...' );
			jQuery.ajax({
				url: stage.url.save,
				data: {
					"action": "save",
					"data": stage.serialize(),
					"user": app.user,
					"token": app.token,
				},
				type: "post",
				error: function( jqX, status ) {
					alert( "Sorry, but your snowman could not be saved. Please try again." );
				},
				success: function( response ) {
					try {
						result = JSON.parse( response );
						if ( result.status && result.status === "success" ) {
							app.user = result.user; // Store new user
							app.token = result.token;    // Store new token
							setCookie( 'user', app.user, .1 ); // Save user ID as a cookie
							jQuery( '#share-url' ).html( 'Your url is: <a href="' + stage.url.card + '">https:' + stage.url.card + "</a>" );
							button.text( 'Saved' );
							if ( app.user ) {  // Set preview image url
								jQuery( "#preview-image" ).attr( "src", "//" + app.siteurl + "/cards/" + app.user + ".jpg" );
							}
                            window.history.replaceState( { app: app, url: document.stage.url.card }, "Build Your Snowman Card", document.stage.url.card );
						} else {
							throw {};
						}
					} catch ( e ) {
						console.log( e );
						console.log( response );
						alert( "Sorry. An error occured, and your snowman could not be saved. Please try again." );
					}
				}
			});

			return stage;
		},

		/**
		 * Loads a previously saved snowman (using a user id)
		 *
		 * @param string user id
		 */
		load: function( user ) {
			user = user || app.user;

			if ( ! user ) { return; }

			jQuery.ajax({
				url: stage.url.reload,
				data: {
					"action": "reload",
					"user": user
				},
				type: "post",
				error: function( jqX, status ) {
					console.warn( "Could not load snowman data." );
					console.warn( status );
				},
				success: function( response ) {
					try {
						result = JSON.parse( response );  // The response was serialized
						if ( result.status && result.status === "success" ) {
							stage.clear().draw( result.data );
                            data = JSON.parse( result.data );  // The data was ALSO serialized in the response
							setTimeout(function() {
								document.setNorthernLights( data.northern_lights );
							}, 3000);
							app.loaded = true;
						} else {
							throw {};
						}
					} catch ( e ) {
						console.warn( "Could not load snowman data." );
						console.log( response );
						console.log( e );
					}
				}
			});

			return stage;
		},

		/**
		 * Puts stage in preview state to prevent edits.
		 */
		preview: function() {
			// Hide any potential rotation controls
			if ( this.rotationControl ) {
				this.rotationControl.hide();
			}

			// de-select everything
			jQuery( this.selectedElement ).removeClass( SELECTED );
			this.selectedItem = null;

			if ( app.user ) {
				jQuery( "#preview-image" ).show();
			} else {
				jQuery( "#preview-image" ).hide();
			}

			// Prevent edits on stage
			jQuery( this.element ).addClass( "preview" );
		},

		/**
		 * Puts stage in edit state to allow edits.
		 */
		edit: function() {
			jQuery( this.element ).removeClass( "preview" );
			this.selectTopmostItem();  // Select top item
			jQuery( '.save-button .editor-functions-toolbar__button__description').text('Save');  // Change save text from saved to save.
		},

	}

	document.stage = stage.init();


	/**
	 * Force element scaling
	 */
	var boo = function boo () {
		// resize based on 560 width
		if( jQuery(window).width() > (560 * 1) ){
			jQuery('svg').each( function(){
				jQuery(this).width( jQuery(this).data('width') / 560 * (560 * 1) );
				jQuery(this).height( jQuery(this).data('width') / 560 * (560 * 1) );

			});
		}else{
			jQuery('svg').each( function(){
				jQuery(this).width( jQuery(this).data('width') / 560 * jQuery(window).width() * 1.25 );
				jQuery(this).height( jQuery(this).data('width') / 560 * jQuery(window).width() * 1.25 );

			});
		}

	}

	boo();

	jQuery(window).resize( function(){
		boo();
	})



	document.body.onkeyup = function(e){
		// Space key
		if(e.keyCode == 32){
			stage.save();
		}

		// Backspace key
		if(e.keyCode == 8){
			stage.undo();
		}

		// Delete key
		if(e.keyCode == 46){
			stage.delete();
		}

		// 'B' key
		if(e.keyCode == 66) {
			jQuery('.rabbit').show();
			setTimeout(function() { jQuery('.rabbit').hide(); }, 20000);
		}

		// 'U' key
		if(e.keyCode == 85) {
			jQuery('.ufo').show();
			setTimeout(function() { jQuery('.ufo').hide(); }, 10000);
		}

		// 'L' key
		if(e.keyCode == 76) {
			document.setNorthernLights( ! stage.northern_lights );
		}

		// 'F' key
		if(e.keyCode == 70) {
			document.stage.flipItem();
		}

		// 'S' key
		if(e.keyCode == 83) {
			if( jQuery('.snowContainer').is(":visible")) {
				jQuery('.snowContainer').hide();
			} else {
				jQuery('.snowContainer').show();
			}
		}
	}

	jQuery('.object-toolbar__inner').addClass('hide');
	jQuery('#menu-head').removeClass('hide');
	jQuery('.object-category-toolbar__option--head').addClass('selected');

	jQuery('.object-category-toolbar__option--head').on('click tap', function( event ) {
		jQuery('.object-category-toolbar__option').removeClass('selected');
		jQuery('.object-category-toolbar__option--head').addClass('selected');
		jQuery('.object-toolbar__inner').addClass('hide');
		jQuery('#menu-head').removeClass('hide');
		jQuery('.object-toolbar__options').slick('setPosition');
	});

	jQuery('.object-category-toolbar__option--upper-torso').on('click tap', function( event ) {
		jQuery('.object-category-toolbar__option').removeClass('selected');
		jQuery('.object-category-toolbar__option--upper-torso').addClass('selected');
		jQuery('.object-toolbar__inner').addClass('hide');
		jQuery('#menu-torso').removeClass('hide');
		jQuery('.object-toolbar__options').slick('setPosition');
	});

	jQuery('.object-category-toolbar__option--lower-torso').on('click tap', function( event ) {
		jQuery('.object-category-toolbar__option').removeClass('selected');
		jQuery('.object-category-toolbar__option--lower-torso').addClass('selected');
		jQuery('.object-toolbar__inner').addClass('hide');
		jQuery('#menu-lower').removeClass('hide');
		jQuery('.object-toolbar__options').slick('setPosition');
	});

	jQuery('.object-category-toolbar__option--accessories').on('click tap', function( event ) {
		jQuery('.object-category-toolbar__option').removeClass('selected');
		jQuery('.object-category-toolbar__option--accessories').addClass('selected');
		jQuery('.object-toolbar__inner').addClass('hide');
		jQuery('#menu-accessories').removeClass('hide');
		jQuery('.object-toolbar__options').slick('setPosition');
	});

	jQuery('.object-category-toolbar__option--scene').on('click tap', function( event ) {
		jQuery('.object-category-toolbar__option').removeClass('selected');
		jQuery('.object-category-toolbar__option--scene').addClass('selected');
		jQuery('.object-toolbar__inner').addClass('hide');
		jQuery('#menu-scene').removeClass('hide');
		jQuery('.object-toolbar__options').slick('setPosition');
	});

	jQuery('.object-toolbar__options').each(function (idx, item) {
		// jQuery('.object-toolbar__options').slick({
		var carouselId = "carousel" + idx;
		this.id = carouselId;

		jQuery(this).slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 9,
			slidesToScroll: 4,
			prevArrow: jQuery(this).parent().find('.object-toolbar__left-arrow'),
			nextArrow: jQuery(this).parent().find('.object-toolbar__right-arrow'),
			responsive: [{
					breakpoint: 3000,
					settings: {
						slidesToShow: 9,
						slidesToScroll: 3
					}
				}, {
					breakpoint: 2000,
					settings: {
						slidesToShow: 7,
						slidesToScroll: 3
					}
				}, {
					breakpoint: 1024,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 3
					}
				}, {
					breakpoint: 700,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 2
					}
				}, {
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	});








	// Will it be a storm or peaceful?
	var COUNT = 300;

	// Get our cotaniner
	var snowContainer = document.querySelector('.snowContainer');

	// Create the canvas element
	var canvas = document.createElement('canvas');
	var ctx = canvas.getContext('2d');
	snowContainer.appendChild(canvas);


	// Get the size of the container, that's why we defined the height in the HTML
	var width = snowContainer.clientWidth;
	var height = snowContainer.clientHeight;
	var i = 0;
	var active = false;

	function onResize() {
		width = snowContainer.clientWidth;
		height = snowContainer.clientHeight;
		canvas.width = width;
		canvas.height = height;
		ctx.fillStyle = '#FFF';

		// update();
		for (i = 0; i < COUNT; i++) {
			snowflake = snowflakes[i];
			snowflake.reset();
		}
	}

	var Snowflake = function() {
		this.x = 0;
		this.y = 0;
		this.vy = 0;
		this.vx = 0;
		this.r = 0;

		this.reset();
	}

	// You can set up the
	Snowflake.prototype.reset = function() {
		this.x = Math.random() * width;
		this.y = Math.random() * -height;

		// More speed? Change this
		this.vy = 1 + Math.random() * .3;
		this.vx = 0.5 - Math.random();

		// Bigger snow?
		this.r = 1 + Math.random() * 2;

		this.o = 0.5 + Math.random() * 0.5;
	}

	canvas.style.position = 'absolute';
	canvas.style.left = canvas.style.top = '0';

	var snowflakes = [],
		snowflake;
	for (i = 0; i < COUNT; i++) {
		snowflake = new Snowflake();
		snowflake.reset();
		snowflakes.push(snowflake);
	}

	function update() {

		ctx.clearRect(0, 0, width, height);

		for (i = 0; i < COUNT; i++) {
			snowflake = snowflakes[i];
			snowflake.y += snowflake.vy;
			snowflake.x += snowflake.vx;

			ctx.globalAlpha = snowflake.o;
			ctx.beginPath();
			ctx.arc(snowflake.x, snowflake.y, snowflake.r, 0, Math.PI * 2, false);
			ctx.closePath();
			ctx.fill();

			if (snowflake.y > height) {
				snowflake.reset();
			}
		}

		requestAnimFrame(update);
	}
	setTimeout(update, 5000);

	// shim layer with setTimeout fallback
	window.requestAnimFrame = (function() {
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			function(callback) {
				window.setTimeout(callback, 1000 / 60);
			};
	})();

	onResize();
	window.addEventListener('resize', onResize, false);




/**
 * SVG Fixer
 *
 * Fixes references to inline SVG elements when the <base> tag is in use.
 * Firefox won't display SVG icons referenced with
 * `<svg><use xlink:href="#id-of-icon-def"></use></svg>` when the <base> tag is on the page.
 *
 * More info:
 * - http://stackoverflow.com/a/18265336/796152
 * - http://www.w3.org/TR/SVG/linking.html
 *
 * One would think that setting the `xml:base` attribute fixes things,
 * but that is being removed from the platform: https://code.google.com/p/chromium/issues/detail?id=341854
 */

(function(document, window) {
	"use strict";

	/**
	* Initialize the SVG Fixer after the DOM is ready
	*/
	document.addEventListener("DOMContentLoaded", function() {

		/**
		 * Current URL, without the hash
		 */
		var baseUrl = window.location.href
			.replace(window.location.hash, "");

		/**
		*  Find all `use` elements with a namespaced `href` attribute, e.g.
		*  <use xlink:href="#some-id"></use>
		*
		*  See: http://stackoverflow.com/a/23047888/796152
		*/
		[].slice.call(document.querySelectorAll("use[*|href]"))

			/**
			* Filter out all elements whose namespaced `href` attribute doesn't
			* start with `#` (i.e. all non-relative IRI's)
			*
			* Note: we're assuming the `xlink` prefix for the XLink namespace!
			*/
			.filter(function(element) {
				return (element.getAttribute("xlink:href").indexOf("#") === 0);
			})

			/**
			* Prepend `window.location` to the namespaced `href` attribute value,
			* in order to make it an absolute IRI
			*
			* Note: we're assuming the `xlink` prefix for the XLink namespace!
			*/
			.forEach(function(element) {
				element.setAttribute("xlink:href", baseUrl + element.getAttribute("xlink:href"));
			});

	}, false);

}(document, window));

});


function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length,c.length);
        }
    }
    return "";
}




// var snowContainer = document.querySelector('.snowContainer');
// var canvas = document.createElement('canvas');
// snowContainer.appendChild(canvas);
/**
 *  Makes a Canvas element that simulates Northern Lights
 */

// settings
var DEBUG = false; // draw the debug line so we can see what it's doing, helps if you turn off the blur filter, too
var CURVE_POINTS = 10; // curve control points, not counting vanishingPoint
var CURVE_POINT_X_JITTER = 1.5; // how far off the base location a point can go, in percentage of difference from previous point
var CURVE_POINT_Y_JITTER = 3.5;
var CURVE_POINT_MAX_FLOAT_X_DIST = 270; // farthest a curve point can float per keyframe
var CURVE_POINT_MAX_FLOAT_Y_DIST = 80;
var CURVE_POINT_MIN_FLOAT_DIST = 15;
var CURVE_POINT_MAX_FLOAT_TIME = 9000; // longest a curve point can take to get to next keyframe
var CURVE_POINT_MIN_FLOAT_TIME = 3000; // shortest a curve point can take to get to next keyframe
var BRUSH_COUNT = 1000;
var BRUSH_WIDTH = 30;
var BRUSH_HEIGHT = 450;
var BRUSH_MIN_SCALE_Y = .02;
var BRUSH_MAX_SCALE_Y_VARIANCE = .5;
var BRUSH_MAX_ALPHA_VARIANCE = .7;
var BRUSH_MAX_ANIM_TIME = 7000;
var BRUSH_MIN_ANIM_TIME = 1500;
var BRUSH_MAX_Z_ANIM_TIME = 80000;
var BRUSH_MIN_Z_ANIM_TIME = 58000;
var BRUSH_ALPHA_DROPOFF = .07;
var MOUSE_X_OFFSET = 50;
var MOUSE_Y_OFFSET = 25;
var mouseXPercentage = .5;
var mouseYPercentage = .5;

/**
 * get point in bezier curve
 * @param point0 X
 * @param point0 Y
 * @param control point 0 X
 * @param control point 0 Y
 * @param control point 1 X
 * @param control point 1 Y
 * @param point 1 X
 * @param point 1 Y
 * @param percentage on path to get point of
 *
 * see http://stackoverflow.com/questions/14174252/how-to-find-out-y-coordinate-of-specific-point-in-bezier-curve-in-canvas
 */
function deCasteljau (p0x, p0y, cp0x, cp0y, cp1x, cp1y, p1x, p1y, t) {
  // In the first step of the algorithm we draw a line connecting p0 and cp0,
  // another line connecting cp0 and cp1, and another still connecting cp1 and p1.
  // Then for all 3 of these lines we're going to find the point on them that is
  // t % from the start of them.
  var Ax = p0x + (t * (cp0x - p0x)),
      Ay = p0y + (t * (cp0y - p0y)),
      Bx = cp0x + (t * (cp1x - cp0x)),
      By = cp0y + (t * (cp1y - cp0y)),
      Cx = cp1x + (t * (p1x - cp1x)),
      Cy = cp1y + (t * (p1y - cp1y));
  // The second step is very much like the first. In the first we connected the
  // four points with lines and then found 3 new points on them. In this step
  // we'll connect those 3 points with lines find 2 new points on them. I'll
  // call these two new points D and E.
  var Dx = Ax + (t * (Bx - Ax)),
      Dy = Ay + (t * (By - Ay)),
      Ex = Bx + (t * (Cx - Bx)),
      Ey = By + (t * (Cy - By));
  // Finally, we can connect these last two points with another line, and find
  // the last point on it which will give us the point on the bezier curve for
  // that t. I'll call this point P.
  var Px = Dx + (t * (Ex - Dx)),
      Py = Dy + (t * (Ey - Dy));

  return {
    x: Px,
    y: Py
  };
}

/**
 * curve controller
 * @param vanishingPoint X (where the first point locks)
 * @param vanishingPoint Y
 * @param endPoint X (where the last point starts, but it floats)
 * @param endPoint Y
 * [@param brushCount] how many brushes to put on the curve
 * [@param maxBrushAlpha] maximum alpha for brushes, defaults to 1
 * [@param fill] color or canvasGradient to fill the brushes with
 */
var Curve = function (vpX, vpY, vpZ, epX, epY, epZ, brushCount, maxBrushAlpha, fill) {
  // define where the point locks
  this.vanishingPoint = {
    x: vpX,
    y: vpY,
    z: vpZ
  };
  this.endPoint = {
    x: epX,
    y: epY,
    z: epZ
  }
  this.brushCount = brushCount || BRUSH_COUNT;
  this.maxBrushAlpha = maxBrushAlpha || 1;

  this.points = [
    new CurvePoint (this.vanishingPoint.x, this.vanishingPoint.y, this.vanishingPoint.z, 0)
  ];
  // add in-between points
  for (var i = 0; i < CURVE_POINTS - 1; i++) {
    // modifier to fake distance
    var mod = (i + 1) / CURVE_POINTS;
    mod *= mod;

    // randomly generate some points
    var xJitter = Math.random() * CURVE_POINT_X_JITTER - CURVE_POINT_X_JITTER / 2;
    var x = this.vanishingPoint.x + mod * (this.endPoint.x - this.vanishingPoint.x);
    x += xJitter * (x - this.points[i].x);
    var yJitter = (1.2 - mod) * (Math.random() * CURVE_POINT_Y_JITTER - CURVE_POINT_Y_JITTER / 2);
    var y = this.vanishingPoint.y + mod * (this.endPoint.y - this.vanishingPoint.y);
    y += yJitter * (y - this.points[i].y);
    var z = mod * (this.endPoint.z - this.vanishingPoint.z) + this.vanishingPoint.z;

    this.points.push(new CurvePoint (x, y, z, ((Math.random() * .33 + .33) * (x - this.points[i].x))));
  }
  // add last point
  this.points.push(new CurvePoint (this.endPoint.x, this.endPoint.y, this.endPoint.z, 0));

  // create brushes
  this.brushes = [];
  for (var i = 0; i < this.brushCount; i++) {
    var noScale = Math.random() < .01;
    this.brushes.push(
      new Brush(
        this,
        (i / this.brushCount) * (this.endPoint.z - this.vanishingPoint.z) + this.vanishingPoint.z,
        noScale ? "rgb(200, 200, 220)" : fill || null,
        noScale
      )
    );
  }
}
Curve.prototype = {
  drawDebug: function (ctx) {
    // mostly just for debug
    ctx.lineWidth = 2;
    // cp lines
    ctx.setLineDash([2,2]);
    ctx.strokeStyle = "#f99";
    for (var i = 1, len = this.points.length; i < len; i++) {
      ctx.beginPath();
      var cps = this.points[i].getCps();
      ctx.moveTo(cps[0].x, cps[0].y);
      //ctx.lineTo(this.points[i].x, this.points[i].y);
      ctx.lineTo(cps[1].x, cps[1].y);
      ctx.stroke();
    }

    // build the bezier paths
    var bezierPoints = [];
    for (var i = 0, len = this.points.length; i < len; i++) {
      var cps = this.points[i].getCps();
      if (i !== 0) {
        bezierPoints.push(cps[0]);
      }
      bezierPoints.push(this.points[i]);
      if (i !== len - 1) {
        bezierPoints.push(cps[1]);
      }
    }
    ctx.beginPath();
    ctx.setLineDash([]);
    ctx.strokeStyle = "#c00";
    ctx.moveTo(bezierPoints[0].x, bezierPoints[0].y);
    for (var i = 1, len = bezierPoints.length; i < len; i += 3) {
      ctx.bezierCurveTo(bezierPoints[i].x, bezierPoints[i].y, bezierPoints[i+1].x, bezierPoints[i+1].y, bezierPoints[i+2].x, bezierPoints[i+2].y);
    }
    ctx.stroke();
  },
  draw: function (ctx) {
    for (var i = 0, len = this.brushes.length; i < len; i++) {
      this.brushes[i].draw(ctx);
    }
  },
  getPointAtZ: function (p) {
    if (p <= this.points[0].z) {
      return this.points[0];
    }
    else if (p >= this.points[this.points.length - 1].z) {
      console.log('over');
      return this.points[this.points.length - 1];
    }
    else {
      var i = 0;
      for (var len = this.points.length; i < len; i++) {
        if (p <= this.points[i].z) {
          break;
        }
      }
      var lastPoint = this.points[i - 1];
      var lastPointCps = lastPoint.getCps();
      var nextPoint = this.points[i];
      var nextPointCps = nextPoint.getCps();
      var t = (p - lastPoint.z) / (nextPoint.z - lastPoint.z);
      return deCasteljau (lastPoint.x, lastPoint.y, lastPointCps[1].x, lastPointCps[1].y, nextPointCps[0].x, nextPointCps[0].y, nextPoint.x, nextPoint.y, t);
    }
  },
  update: function () {
    // update point positions for floating effect
    for (var i = 0, len = this.points.length; i < len; i++) {
      this.points[i].updatePosition();
    }
    // update brush properties for floating effect
    for (var i = 0, len = this.brushes.length; i < len; i++) {
      this.brushes[i].updatePosition();
    }
  },
  setMaxBrushAlpha: function (alpha) {
    this.maxBrushAlpha = alpha;
  }
}

/**
 * curve points
 * @param startX
 * @param startY
 * @param z (affects how much it moves, 0-1)
 */
var CurvePoint = function (x, y, z, cpLength) {
  this.x = x;
  this.y = y;
  this.z = z;
  this.cpLength = cpLength;
  this.cpYOffset = Math.random() * cpLength - cpLength;

  // set up floating
  this.xAnimTime = Math.random() * (CURVE_POINT_MAX_FLOAT_TIME - CURVE_POINT_MIN_FLOAT_TIME) + CURVE_POINT_MIN_FLOAT_TIME;
  this.xVariance = Math.max(Math.random() * this.z * (CURVE_POINT_MAX_FLOAT_X_DIST), CURVE_POINT_MIN_FLOAT_DIST);
  this.xMin = this.x - this.xVariance / 2;
  this.xAnimOffset = Math.random() * Math.PI;

  this.yAnimTime = Math.random() * (CURVE_POINT_MAX_FLOAT_TIME - CURVE_POINT_MIN_FLOAT_TIME) + CURVE_POINT_MIN_FLOAT_TIME;
  this.yVariance = Math.max(Math.random() * this.z * (CURVE_POINT_MAX_FLOAT_Y_DIST), CURVE_POINT_MIN_FLOAT_DIST);
  this.yMin = this.y - this.yVariance / 2;
  this.yAnimOffset = Math.random() * Math.PI;
}
CurvePoint.prototype = {
  getCps: function () {
    return [
      {
        x: this.x - this.cpLength,
        y: this.y - this.cpYOffset
      },
      {
        x: this.x + this.cpLength,
        y: this.y + this.cpYOffset
      }
    ]
  },
  updatePosition: function () {
    if (!this.startTime)
      this.startTime = new Date().getTime();
    var now = new Date().getTime();
    var deltaTime = now - this.startTime;

    this.x = this.xMin + (Math.sin((deltaTime / this.xAnimTime) * Math.PI + this.xAnimOffset) * .5 + .5) * this.xVariance;
    this.x += this.z * (1 - mouseXPercentage * 2) * MOUSE_X_OFFSET;
    this.y = this.yMin + (Math.sin((deltaTime / this.yAnimTime) * Math.PI + this.yAnimOffset) * .5 + .5) * this.yVariance;
    this.y += this.z * (1 - mouseYPercentage * 2) * MOUSE_Y_OFFSET;
  }
}

/**
 *  Brushes
 *  Jitters are created on init
 *  @param curve - what curve the brush sits on
 *  @param z - where on the line the brush sits
 */
var Brush = function (curve, z, color, noScale) {
  this.curve = curve;
  this.z = z;
  this.alpha = z * Math.random() * .55 + .15;
  this.scaleYMod = (1 - BRUSH_MIN_SCALE_Y) * Math.random();
  this.scaleXMod = .5 * Math.random() * (2 - this.scaleYMod * 2);
  this.noScale = !!noScale;
  this.color1 = color || "rgb(50, 170, 82)";

  // timings
  this.alphaAnimTime = Math.random() * (BRUSH_MAX_ANIM_TIME - BRUSH_MIN_ANIM_TIME) + BRUSH_MIN_ANIM_TIME;
  this.alphaVariance = Math.max(Math.random() * BRUSH_MAX_ALPHA_VARIANCE, this.alpha);
  this.alphaMin = Math.max(this.alpha - this.alphaVariance / 2, 0);
  this.alphaAnimOffset = Math.random() * Math.PI;

  this.scaleYAnimTime = Math.random() * (BRUSH_MAX_ANIM_TIME - BRUSH_MIN_ANIM_TIME) + BRUSH_MIN_ANIM_TIME;
  this.scaleYVariance = Math.random() * BRUSH_MAX_SCALE_Y_VARIANCE;
  this.scaleYMin = this.scaleY - this.scaleYVariance / 2;
  this.scaleYAnimOffset = Math.random() * Math.PI;

  this.zAnimOffset = this.curve.vanishingPoint.z - (z - this.curve.vanishingPoint.z);
  this.zAnimTime = Math.random() * (BRUSH_MAX_Z_ANIM_TIME - BRUSH_MIN_Z_ANIM_TIME) + BRUSH_MIN_Z_ANIM_TIME;

  if (this.noScale) {
    this.alphaMin = 0;
    this.alphaVariance = 1;
  }
}
Brush.prototype = {
  draw: function (ctx) {
    if (this.z < this.curve.vanishingPoint.z || this.z > this.curve.endPoint.z)
      return false;

    var point = this.curve.getPointAtZ(this.z);

    var alpha = ((.5 + .5 * Math.min(this.z, 1)) * this.alpha * this.curve.maxBrushAlpha);
    if (this.z - this.curve.vanishingPoint.z < BRUSH_ALPHA_DROPOFF) {
      alpha *= (this.z - this.curve.vanishingPoint.z) / BRUSH_ALPHA_DROPOFF;
    }
    else if (this.curve.endPoint.z - this.z < BRUSH_ALPHA_DROPOFF) {
      alpha *= (this.curve.endPoint.z - this.z) / BRUSH_ALPHA_DROPOFF;
    }

    if (!this.noScale) {
      var scaleY = this.z * this.scaleYMod + BRUSH_MIN_SCALE_Y;
      var scaleX = this.z * this.scaleXMod + .5;
    }
    else {
      var scaleY = this.scaleYMod + BRUSH_MIN_SCALE_Y;
      var scaleX = this.scaleXMod + .5;
    }

    ctx.fillStyle = this.color1;
    ctx.globalAlpha = alpha;

    ctx.beginPath();
    ctx.moveTo(point.x, point.y - scaleY * BRUSH_HEIGHT);
    ctx.quadraticCurveTo(point.x + scaleX * BRUSH_WIDTH / 2, point.y - scaleY * BRUSH_HEIGHT, point.x + scaleX * BRUSH_WIDTH / 2, point.y);
    ctx.quadraticCurveTo(point.x + scaleX * BRUSH_WIDTH / 2, point.y + scaleY * BRUSH_WIDTH, point.x, point.y + scaleX * BRUSH_WIDTH / 2);
    ctx.quadraticCurveTo(point.x - scaleX * BRUSH_WIDTH / 2, point.y + scaleY * BRUSH_WIDTH, point.x - scaleX * BRUSH_WIDTH / 2, point.y);
    ctx.quadraticCurveTo(point.x - scaleX * BRUSH_WIDTH / 2, point.y - scaleY * BRUSH_HEIGHT, point.x, point.y - scaleY * BRUSH_HEIGHT);
    ctx.fill();

    // ctx.globalAlpha = alpha;
    // ctx.drawImage(this.image, point.x - scaleX * BRUSH_WIDTH / 2, point.y - scaleY * BRUSH_HEIGHT, scaleX * BRUSH_WIDTH, scaleY * BRUSH_HEIGHT);
  },
  updatePosition: function () {
    if (!this.startTime)
      this.startTime = new Date().getTime() - 20000;
    var now = new Date().getTime();
    var deltaTime = now - this.startTime;

    this.alpha = Math.min(this.alphaMin + (Math.sin((deltaTime / this.alphaAnimTime) * Math.PI + this.alphaAnimOffset) * .5 + .5) * this.alphaVariance, 1);
    this.scaleY = this.scaleYMin + (Math.sin((deltaTime / this.scaleYAnimTime) * Math.PI + this.scaleYAnimOffset) * .5 + .5) * this.scaleYVariance;
    //this.z = this.zMin + (Math.sin((deltaTime / this.zAnimTime) * Math.PI + this.zAnimOffset) * .5 + .5) * this.zVariance;
    this.z = ((deltaTime / this.zAnimTime) + this.zAnimOffset) * this.curve.endPoint.z;
    if (this.z > this.curve.vanishingPoint.z)
      this.z *= this.z;
    if (this.z > this.curve.endPoint.z) {
      this.z = (this.z - this.curve.endPoint.z) + this.curve.vanishingPoint.z;
      // reset start time so it doesn't infinitely speed up
      this.startTime = now;
    }
  }
}

// make a canvas and do stuff
/**
 *  NorthernLights class
 *  Creates a canvas that immitates the northern lights
 *  @param parentElement - DOMElement to append the canvas to
 *  [@param width] - width of canvas, defaults to window size on creation
 *  [@param height] - height of canvas, defaults to window size on creation
 *  [@param curves] - an array of Curve objects to use, creates one if omitted
 */
var NorthernLightsDiv = {};
var NorthernLights = function (parentElement, width, height, curves) {
	// DEBUG = true;
  this.parentElement = parentElement;
  this.width = width || window.innerWidth;
  this.height = height || window.innerHeight;
  this.height = (this.height * .5);
  this.canvas = document.createElement('canvas');
  this.canvas.width = this.width;
  this.canvas.height = this.height;
  this.ctx = this.canvas.getContext('2d');
  this.ctx.globalCompositeOperation = "color-dodge";

  // make a new random curve if one wasn't passed
  this.curves = curves || [new Curve (this.width * .1, this.height * .59, this.width * .9, this.height * .24)];

  if (DEBUG) {
    this.fpsDisplay = document.createElement('span');
    this.fpsDisplay.style.position = "fixed";
    this.fpsDisplay.style.top = "0";
    this.fpsDisplay.style.left = "0";
    this.fpsDisplay.style.background = "#333";
    this.fpsDisplay.style.color = "#0f0";
    document.body.appendChild(this.fpsDisplay);
  }

  // auto start
  this.start();
  var lightsContainer = document.querySelector('.lightsContainer');
  // var canvas = document.createElement('canvas');
  NorthernLightsDiv = this.canvas
  lightsContainer.appendChild(NorthernLightsDiv);
  // lightsContainer.insertBefore(this.canvas, document.querySelector('.scenery__container__background__mountains'));
}
NorthernLights.prototype = {
  start: function () {
	  console.log('Start');
    this.running = true;
    var _this = this;
    var lastTime = new Date().getTime();
    (function anim () {
      // clear current
      _this.ctx.clearRect(0,0,_this.width,_this.height);
      for (var i = 0, len = _this.curves.length; i < len; i++) {
        // update positions
        _this.curves[i].update();
        // put that bitch on the canvas
        _this.curves[i].draw(_this.ctx);
        // debug line?
        if (DEBUG) {
          _this.ctx.globalCompositeOperation = "source-over";
          _this.ctx.globalAlpha = 1;
          _this.curves[i].drawDebug(_this.ctx);
          _this.ctx.globalCompositeOperation = "color-dodge";

          var now = new Date().getTime();
          _this.fpsDisplay.innerText = Math.round(1000 / (now - lastTime));
          lastTime = now;
        }
      }
      if (_this.running)
        requestAnimationFrame(anim);
    })()
  },
  pause: function () {
    this.running = false;
  },
  getCanvas: function () {
    return this.canvas;
  },
  getCurves: function () {
    return this.curves;
  }
}

var gradCanvas = document.createElement('canvas');
var gradCtx = gradCanvas.getContext('2d');
var grad = gradCtx.createLinearGradient(window.innerWidth * .5, window.innerHeight, window.innerWidth * .35, 0);
grad.addColorStop(.4, "rgb(50, 130, 140)");
grad.addColorStop(.6, "rgba(100, 100, 120, .5)");
var grad2 = gradCtx.createLinearGradient(window.innerWidth * .5, window.innerHeight * .5, window.innerWidth * .3, 0);
grad2.addColorStop(.35, "rgb(50, 130, 80)");
grad2.addColorStop(.7, "rgba(50, 70, 100,.7)");

var curves = [
  new Curve (window.innerWidth * .17, window.innerHeight * .94, .01, window.innerWidth * .8, window.innerHeight * .8, .8, BRUSH_COUNT * .3, .4, "rgb(60, 150, 120)"),
  new Curve (window.innerWidth * .1, window.innerHeight * .9, .05, window.innerWidth * .8, window.innerHeight * .4, 1, null, .8, grad),
  new Curve (window.innerWidth * .25, window.innerHeight * .65, .33, window.innerWidth * .55, 0, 1.1, BRUSH_COUNT * .6, 1, grad2)
]
